import React, { Component } from 'react';
import { Breadcrumb,Icon,Button,Radio,Input,Card} from 'antd';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import Question from '../../../entry_question_editor/question/question_view/view';

import {action} from './';

const RadioGroup = Radio.Group;

class ErrorDuty extends Component{
    state={
        question_id:'',
        is_search:0,
    }
    handleSearch = () => {
        const { question_id, is_search } = this.state;
        this.getErrorDuty(is_search,question_id );
        this.setState({
            searching:true
        })
    }
    handleChange = (e) => {
        this.setState({
            question_id:e.target.value
        })
    }
    onRadioChange = (e) => {
        this.setState({
            is_search: e.target.value
        })
    }
    getErrorDuty = (is_search=0,question_id) => {
        let { getErrorDuty } = this.props;
        getErrorDuty({is_search,question_id}, () => {

        });
    }
    render(){
        let {question_id} = this.state
        let questionDetail = this.props.data;
        return(
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <Link to="/questionbox">题盒子</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>错题追责</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div style={{marginTop:15}}>
                    <div>
                        <div style={{width:200,display:'inline-block',marginRight:20}}>
                            <Input onChange ={ this.handleChange } placeholder="输入题目ID" value={question_id} size="large" />
                        </div>
                        <RadioGroup onChange={this.onRadioChange} value={this.state.is_search}>
                            <Radio value={1}>搜索</Radio>
                            <Radio value={0}>自录</Radio>
                        </RadioGroup>
                        <Button disabled={ question_id == '' } onClick= { this.handleSearch } type="primary" size="large" icon="search">搜索</Button>
                    </div>
                    <div style={{width:'100%',marginTop:20,padding:10,boxSizing:'border-box',minHeight:300}}>
                        {
                            ( questionDetail.error == ''  && questionDetail.questionInfo.item_list ) &&
                            <Card>
                                <div style={{fontSize:14,lineHeight:2}}>
                                    {/*日志信息*/}
                                    <div>任务名：{questionDetail.taskInfo.name}</div>
                                    <div>
                                        <span style={{marginRight:10}}>录入员：{questionDetail.entry_user.name} </span>
                                        <span style={{marginRight:10}}>所属小组：{questionDetail.taskInfo.entry_group}</span>
                                        <span style={{marginRight:10}}>校验员：{questionDetail.check_user.name}</span>
                                    </div>
                                    <div>
                                        题目日志：
                                        {
                                            questionDetail.question_log.map((v,k) =>
                                                <div style={{paddingLeft:'10px'}} key={k} >
                                                    <span style={{marginRight:10}}>用户名：{v.user_name}</span>
                                                    <span style={{marginRight:10}}>手机号：{v.user_name}</span>
                                                    <span style={{marginRight:10}}>创建时间：{v.create_time}</span>
                                                    <span >操作：{v.stage_name}</span>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <Question data={questionDetail.questionInfo} num={1} />
                                </div>
                            </Card>

                        }
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateTopProps = (state) => {
    const errorDuty = state.questionBox.errorDuty;
    return {
        data:errorDuty,
    };
}
const mapDispatchToProps = dispatch => {
    return ({
        getErrorDuty:(val)=>{
            dispatch(action.getErrorDuty(val))
        }
    });
};
export default connect(mapStateTopProps,mapDispatchToProps)(ErrorDuty)


// WEBPACK FOOTER //
// ./src/entry_app/question_box/error_duty/view.js